/**
 * Auto-generated by tools/content-pipeline.
 * Pack: trivia-era-expansion-v1
 * Item: classic-films-expansion
 * Generated: 2026-07-14T01:18:38.901Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 51 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */

export const generatedClassicFilms = [
  {
    "question": "Which iconic 1942 film starring Humphrey Bogart and Ingrid Bergman is set during World War II?",
    "options": [
      "Casablanca",
      "The Maltese Falcon",
      "Key Largo",
      "To Have and Have Not"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Play it again, Sam! Though the line is never actually spoken exactly like that in the film."
  },
  {
    "question": "Who directed the classic suspense films Psycho and Vertigo?",
    "options": [
      "Alfred Hitchcock",
      "Orson Welles",
      "Stanley Kubrick",
      "Billy Wilder"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He was known as the 'Master of Suspense' for good reason."
  },
  {
    "question": "Which actress played Holly Golightly in the 1961 film Breakfast at Tiffany's?",
    "options": [
      "Audrey Hepburn",
      "Marilyn Monroe",
      "Elizabeth Taylor",
      "Grace Kelly"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Her iconic little black dress and pearls are still a fashion statement."
  },
  {
    "question": "Which actor, famous for his Westerns, was known as 'The Duke'?",
    "options": [
      "John Wayne",
      "Clint Eastwood",
      "Gary Cooper",
      "James Stewart"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He starred in over 170 films, mostly Westerns and war movies."
  },
  {
    "question": "What kind of natural disaster is central to the plot of The Poseidon Adventure (1972)?",
    "options": [
      "A rogue wave (tsunami)",
      "An earthquake",
      "A hurricane",
      "A volcano"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "This disaster film kept audiences on the edge of their seats."
  },
  {
    "question": "Who starred as Maria in the 1965 musical The Sound of Music?",
    "options": [
      "Julie Andrews",
      "Debbie Reynolds",
      "Shirley Jones",
      "Doris Day"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "She warmed hearts with her singing and her caring for the Von Trapp children."
  },
  {
    "question": "Which epic film, directed by David Lean, tells the story of T.E. Lawrence in Arabia?",
    "options": [
      "Lawrence of Arabia",
      "The Bridge on the River Kwai",
      "Doctor Zhivago",
      "Ryan's Daughter"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Its stunning desert cinematography won many awards."
  },
  {
    "question": "Who played James Bond in the first official Eon Productions film, Dr. No (1962)?",
    "options": [
      "Sean Connery",
      "Roger Moore",
      "George Lazenby",
      "Timothy Dalton"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He defined the role for a generation of moviegoers."
  },
  {
    "question": "What is the name of the ship in the film The African Queen (1951), starring Humphrey Bogart and Katharine Hepburn?",
    "options": [
      "The African Queen",
      "The Nile Princess",
      "The Congo Belle",
      "The Jungle Jane"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Bogart won his only Oscar for his role as Charlie Allnut in this film."
  },
  {
    "question": "Which classic musical features Gene Kelly dancing in the rain?",
    "options": [
      "Singin' in the Rain",
      "An American in Paris",
      "On the Town",
      "Easter Parade"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "That iconic dance number took many takes and Gene Kelly had a fever during filming."
  },
  {
    "question": "Who starred as the strong-willed millionaire's daughter Ellie Andrews in It Happened One Night (1934)?",
    "options": [
      "Claudette Colbert",
      "Carole Lombard",
      "Myrna Loy",
      "Jean Harlow"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "This film was one of the first romantic comedies and swept the 'Grand Slam' of Oscars."
  },
  {
    "question": "Which historical epic, directed by William Wyler, features a monumental chariot race and stars Charlton Heston?",
    "options": [
      "Ben-Hur",
      "Spartacus",
      "Cleopatra",
      "The Ten Commandments"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The chariot race sequence is one of the most famous in cinema history."
  },
  {
    "question": "Who played Vito Corleone in The Godfather (1972)?",
    "options": [
      "Marlon Brando",
      "Al Pacino",
      "Robert De Niro",
      "James Caan"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "His performance earned him an Academy Award, which he famously declined."
  },
  {
    "question": "Which film features Judy Garland singing 'Over the Rainbow'?",
    "options": [
      "The Wizard of Oz",
      "Meet Me in St. Louis",
      "A Star Is Born",
      "Easter Parade"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "This song became one of the most beloved movie songs of all time."
  },
  {
    "question": "What is the main setting for the film Doctor Zhivago (1965)?",
    "options": [
      "Russia during the revolution",
      "France during World War II",
      "England during the Victorian era",
      "Italy during the Renaissance"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Its sweeping romance against a backdrop of war captured audiences worldwide."
  },
  {
    "question": "Humphrey Bogart’s character Rick Blaine owned a famous establishment in Casablanca, what was it?",
    "options": [
      "A nightclub/bar",
      "A hotel",
      "A casino",
      "A travel agency"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Everyone came to Rick's, for gambling, drinks, or letters of transit."
  },
  {
    "question": "Who famously starred as Eliza Doolittle in My Fair Lady (1964)?",
    "options": [
      "Audrey Hepburn",
      "Julie Andrews",
      "Natalie Wood",
      "Elizabeth Taylor"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "She transformed from a Cockney flower girl into a refined lady."
  },
  {
    "question": "Which actor, known for his roles in Mr. Smith Goes to Washington and Rear Window, often played honest, everyday men?",
    "options": [
      "James Stewart",
      "Henry Fonda",
      "Spencer Tracy",
      "Gregory Peck"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He had a distinctive drawl and a genuinely kind screen presence."
  },
  {
    "question": "In Alien (1979), who played the iconic hero Ellen Ripley?",
    "options": [
      "Sigourney Weaver",
      "Jamie Lee Curtis",
      "Faye Dunaway",
      "Carrie Fisher"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Her role as Ripley became a groundbreaking portrayal of a female action hero."
  },
  {
    "question": "Which 1969 Western stars Paul Newman as Butch Cassidy and Robert Redford as the Sundance Kid?",
    "options": [
      "Butch Cassidy and the Sundance Kid",
      "The Wild Bunch",
      "True Grit",
      "Once Upon a Time in the West"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Their bicycle ride and the song 'Raindrops Keep Fallin' on My Head' are unforgettable."
  },
  {
    "question": "Which film, set in a mental institution, earned Jack Nicholson an Academy Award for Best Actor in 1975?",
    "options": [
      "One Flew Over the Cuckoo's Nest",
      "The Shining",
      "Five Easy Pieces",
      "Carnal Knowledge"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "It was considered one of the greatest films of its time and swept the major Oscar categories."
  },
  {
    "question": "Who played Mary Poppins in the beloved 1964 Disney musical?",
    "options": [
      "Julie Andrews",
      "Angela Lansbury",
      "Debbie Reynolds",
      "Doris Day"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Her performance earned her an Academy Award for Best Actress."
  },
  {
    "question": "Which actor, famous for playing cowboys, won his only Oscar for True Grit in 1969?",
    "options": [
      "John Wayne",
      "Clint Eastwood",
      "Gary Cooper",
      "Henry Fonda"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He finally won the Oscar for a role that truly showcased his grizzled Western persona."
  },
  {
    "question": "Which film features the iconic parting line, 'Here's looking at you, kid'?",
    "options": [
      "Casablanca",
      "The Maltese Falcon",
      "The Big Sleep",
      "Key Largo"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "It's one of the most quoted lines in cinema history."
  },
  {
    "question": "The 1957 war film The Bridge on the River Kwai is set during which major conflict?",
    "options": [
      "World War II",
      "Korean War",
      "Vietnam War",
      "World War I"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "It tells the dramatic story of British prisoners of war in a Japanese camp."
  },
  {
    "question": "Which film director was known for his psychological thrillers and cameo appearances in his own films?",
    "options": [
      "Alfred Hitchcock",
      "Orson Welles",
      "Billy Wilder",
      "John Ford"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He loved to challenge audiences and keep them guessing."
  },
  {
    "question": "Who played Hannibal Lecter in the 1991 thriller The Silence of the Lambs?",
    "options": [
      "Anthony Hopkins",
      "Bryan Cranston",
      "Kevin Spacey",
      "Jack Nicholson"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "His chilling performance earned him an Academy Award, despite limited screen time."
  },
  {
    "question": "Which 1976 boxing film, starring Sylvester Stallone, became a surprising hit and won Best Picture?",
    "options": [
      "Rocky",
      "Raging Bull",
      "Chariots of Fire",
      "Body and Soul"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Stallone famously wrote the screenplay himself in a few days."
  },
  {
    "question": "Which 1959 film starring Marilyn Monroe, Tony Curtis, and Jack Lemmon features two musicians disguised as women?",
    "options": [
      "Some Like It Hot",
      "Gentlemen Prefer Blondes",
      "Bus Stop",
      "The Seven Year Itch"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The final line, 'Well, nobody's perfect,' is one of cinema's most famous taglines."
  },
  {
    "question": "Which legendary director was known for his Westerns, often starring John Wayne, such as The Searchers?",
    "options": [
      "John Ford",
      "Howard Hawks",
      "Billy Wilder",
      "Elia Kazan"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "He directed over 140 films and won four Best Director Oscars."
  },
  {
    "question": "Who played Dorothy in the 1939 film The Wizard of Oz?",
    "options": [
      "Judy Garland",
      "Shirley Temple",
      "Deanna Durbin",
      "Elizabeth Taylor"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Her performance made her a household name and an American icon."
  },
  {
    "question": "Which actress, known for her strong will and distinctive voice, starred opposite Spencer Tracy in many films?",
    "options": [
      "Katharine Hepburn",
      "Bette Davis",
      "Joan Crawford",
      "Olivia de Havilland"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "She was a fierce talent and won a record four Academy Awards for Best Actress."
  },
  {
    "question": "The 1975 film One Flew Over the Cuckoo's Nest is set in what kind of institution?",
    "options": [
      "A psychiatric hospital",
      "A prison",
      "A boarding school",
      "A nursing home"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "It highlights the struggle for individuality against authoritarian systems."
  },
  {
    "question": "Which 1970 disaster film depicts the attempts to rescue passengers from a damaged airplane?",
    "options": [
      "Airport",
      "The Towering Inferno",
      "Earthquake",
      "Raise the Titanic"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Airport launched the all-star disaster film genre of the 1970s."
  },
  {
    "question": "Who directed the iconic horror film Jaws (1975)?",
    "options": [
      "Steven Spielberg",
      "George Lucas",
      "Francis Ford Coppola",
      "Martin Scorsese"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "This film practically invented the summer blockbuster."
  },
  {
    "question": "Which 1960 film, starring Janet Leigh and Anthony Perkins, features a famous shower scene?",
    "options": [
      "Psycho",
      "Vertigo",
      "Rear Window",
      "North by Northwest"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "It changed horror films forever and made moviegoers think twice about taking a shower."
  },
  {
    "question": "Which actress played the role of Scarlett O'Hara in Gone With the Wind (1939)?",
    "options": [
      "Vivien Leigh",
      "Olivia de Havilland",
      "Bette Davis",
      "Katharine Hepburn"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Her fiery portrayal captivated audiences and earned her an Oscar."
  },
  {
    "question": "In the 1968 film 2001: A Space Odyssey, what is the name of the rebellious artificial intelligence?",
    "options": [
      "HAL 9000",
      "Skynet",
      "Deep Blue",
      "Matrix"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "This groundbreaking film explored themes of artificial intelligence and human evolution."
  },
  {
    "question": "Which famous dance duo starred in many Hollywood musicals, including Top Hat and Swing Time?",
    "options": [
      "Fred Astaire and Ginger Rogers",
      "Gene Kelly and Debbie Reynolds",
      "Donald O'Connor and Vera-Ellen",
      "Mickey Rooney and Judy Garland"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Their elegant dancing set the standard for cinematic ballroom."
  },
  {
    "question": "Who composed the iconic scores for films like Psycho, Vertigo, and North by Northwest?",
    "options": [
      "Bernard Herrmann",
      "Ennio Morricone",
      "John Williams",
      "Henry Mancini"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "His innovative and often unsettling music is inseparable from Hitchcock's films."
  },
  {
    "question": "Which 1952 film directed by Fred Zinnemann stars Gary Cooper as a marshal facing a gang alone?",
    "options": [
      "High Noon",
      "Shane",
      "The Ox-Bow Incident",
      "Rio Bravo"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "This Western classic unfolds almost in real time, building immense suspense."
  },
  {
    "question": "What kind of creature terrorizes the town of Amity Island in the film Jaws?",
    "options": [
      "A great white shark",
      "A giant squid",
      "An octopus",
      "A killer whale"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The chilling music alone was enough to scare people out of the water."
  },
  {
    "question": "Which epic film, released in 1962, stars Peter O'Toole as an eccentric British officer during WWI?",
    "options": [
      "Lawrence of Arabia",
      "Bridge on the River Kwai",
      "Doctor Zhivago",
      "The Guns of Navarone"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Its vast desert landscapes and grand scale made it an instant classic."
  },
  {
    "question": "The 1969 film Midnight Cowboy, about a hustler and a con man, was the first X-rated film to win which Oscar?",
    "options": [
      "Best Picture",
      "Best Director",
      "Best Actor",
      "Best Screenplay"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "The X rating was later changed to R, but its initial rating was very controversial."
  },
  {
    "question": "Which film starring Gregory Peck tells the story of a lawyer defending a black man accused of rape in the American South?",
    "options": [
      "To Kill a Mockingbird",
      "Inherit the Wind",
      "Twelve Angry Men",
      "Judgment at Nuremberg"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Peck's Atticus Finch is considered one of cinema's greatest heroes."
  },
  {
    "question": "Which 1954 film features Marlon Brando as a former prize-fighter who 'coulda been a contender'?",
    "options": [
      "On the Waterfront",
      "A Streetcar Named Desire",
      "The Wild One",
      "Sayonara"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Brando's powerful performance in this film earned him his first Academy Award."
  },
  {
    "question": "Who directed The Godfather and Apocalypse Now?",
    "options": [
      "Francis Ford Coppola",
      "Martin Scorsese",
      "Steven Spielberg",
      "Stanley Kubrick"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "He is one of the most influential filmmakers of the 'New Hollywood' era."
  },
  {
    "question": "Which actress was known as 'The Love Goddess' and starred in films like Gilda (1946)?",
    "options": [
      "Rita Hayworth",
      "Ava Gardner",
      "Lana Turner",
      "Veronica Lake"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Her iconic striptease in Gilda is one of the most famous in film history."
  },
  {
    "question": "What is the name of the beloved extraterrestrial in Steven Spielberg's 1982 film?",
    "options": [
      "E.T. the Extra-Terrestrial",
      "Alf",
      "Gizmo",
      "Yoda"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "His glowing finger and bicycle flight became indelible images."
  },
  {
    "question": "Who composed the iconic theme music for Star Wars (1977)?",
    "options": [
      "John Williams",
      "Jerry Goldsmith",
      "Bernard Herrmann",
      "Henry Mancini"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "His scores have become synonymous with blockbuster films."
  },
  {
    "question": "Which 1973 film, starring Robert Redford and Paul Newman, is a tale of con artists in 1930s Chicago?",
    "options": [
      "The Sting",
      "Butch Cassidy and the Sundance Kid",
      "The Way We Were",
      "All the President's Men"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "It's known for its intricate plot and Ragtime musical score."
  }
] as const;
